import type { Project } from '../components/minimal';

export const vulnerabilities: Project[] = [
  {
    title: 'Linux Kernel io_uring OOB Read',
    target: 'Linux Kernel 6.19',
    description:
      'Out-of-bounds read in io_uring SQE_MIXED handling. The boundary check for 128-byte SQEs validated the logical cached_sq_head position but not the physical index from sq_array — which is userspace-writable. Deterministic, unprivileged 64-byte OOB read.',
    impact: 'Fix merged mainline by Jens Axboe, backported to 6.19-stable by Sasha Levin',
    status: 'merged',
    statusLabel: 'FIX MERGED',
    tags: ['C', 'kernel', 'io_uring', 'memory safety'],
    links: [
      {
        label: 'Writeup & PoC',
        url: 'https://gist.github.com/Atomics-hub/88b2c497166c838cc63633c5ce32c259',
      },
    ],
  },
  {
    title: 'V8 Maglev JIT Uninitialized Memory',
    target: 'Chromium / V8',
    description:
      "Uninitialized saved_mode_ in SaveCallSpeculationScope in V8's Maglev JIT compiler. Submitted to Chromium bug tracker, peaked at P1/S1 severity. Fixed same day by the V8 team.",
    impact: 'Peaked P1/S1 severity — fixed by Victor Gomes, VRP reward pending',
    status: 'fixed',
    statusLabel: 'FIXED',
    tags: ['C++', 'V8', 'JIT', 'Chromium'],
    links: [
      { label: 'Writeup', url: 'https://gist.github.com/Atomics-hub/baf37d7f7402a5011bbed61208872339' },
    ],
  },
  {
    title: 'WebKit / Safari — 5 Bugs',
    target: 'Apple WebKit',
    description:
      "3 WGSL shader compiler bugs, 1 JavaScriptCore bug, and 1 WebGPU IPC bug. Found through source-level auditing of WebKit's GPU process and JS engine. 4 submitted to Apple Security.",
    impact: '5 bugs across 3 WebKit attack surfaces (WGSL, JSC, WebGPU IPC)',
    status: 'submitted',
    statusLabel: '4 SUBMITTED',
    tags: ['C++', 'WGSL', 'JavaScriptCore', 'WebGPU', 'IPC'],
    links: [],
  },
  {
    title: 'XNU Kernel NECP Client UAF',
    target: 'Apple XNU',
    description:
      'Use-after-free race condition in the NECP (Network Extension Control Policy) client. Kernel UAF reachable from the app sandbox. Found through manual source auditing of xnu-12377.81.4.',
    impact: 'Kernel UAF reachable from app sandbox via NECP client race condition',
    status: 'submitted',
    statusLabel: 'SUBMITTED',
    tags: ['C', 'XNU', 'kernel', 'UAF', 'race condition'],
    links: [],
  },
  {
    title: 'macOS Spotlight mdimporter Fuzzing',
    target: 'macOS Spotlight',
    description:
      'Fuzzing campaign targeting 18 Spotlight mdimporter file parsers (PDF, Font, Office, RTF, etc.) in mdworker_shared. Zero-click attack surface — files are parsed automatically on creation.',
    impact: 'Zero-click attack surface: 18 file parsers triggered automatically on file creation',
    status: 'active',
    statusLabel: 'ACTIVE',
    tags: ['fuzzing', 'macOS', 'zero-click', 'file parsers', 'Python'],
    links: [],
  },
  {
    title: 'DoD Vulnerability Disclosure — 2 Bugs',
    target: 'Department of Defense',
    description:
      'Two Keycloak ROPC brute-force vulnerabilities in Department of Defense systems. Submitted through the DoD Vulnerability Disclosure Program on HackerOne.',
    impact: 'Keycloak ROPC brute-force vulnerabilities on DoD authentication systems',
    status: 'submitted',
    statusLabel: 'SUBMITTED',
    tags: ['Keycloak', 'web security', 'DoD', 'HackerOne'],
    links: [],
  },
];

export const consciousnessPaper = {
  title:
    'What Must Be Preserved? Mapping Theories of Consciousness to Engineering Requirements for Mind Preservation',
  meta: 'Thomas Ryan · 2026 · Zenodo · DOI: 10.5281/zenodo.19374628',
  abstract:
    'The engineering of consciousness preservation proceeds largely without reference to theories of consciousness. This paper evaluates eight major theories — IIT 4.0, GNWT, HOT, Predictive Processing, RPT, Biological Computationalism, Orch OR, and AST — against nine preservation-relevant criteria, and derives specific engineering requirements from each theory\u2019s core postulates.',
  findings: [
    'Theories split 4-3-1 on substrate independence',
    'Required compute: 10^15 FLOPS to formally uncomputable',
    'Cryonics is the only strategy compatible with all 8 theories',
    'The primary bottleneck is theory, not engineering',
  ],
  tags: [
    'consciousness',
    'mind preservation',
    'whole-brain emulation',
    'philosophy of mind',
    'neural engineering',
  ],
  links: [
    { label: 'Read Paper', url: 'https://doi.org/10.5281/zenodo.19374628' },
    { label: 'GitHub', url: 'https://github.com/Atomics-hub/consciousness-research' },
  ],
};

export const researchStats = {
  bugsFound: '12+',
  targetsPatched: '4',
  attackSurfaces: '6',
};
